<template>
    <div class="main_wrap">
        <!-- 活动标题 -->
        <div v-wechat-title="'《魔卡少女樱：回忆钥匙》摇一摇领奖'"></div>

        <Header v-if="true" :isOnline="0" :config="headerConfig" :isShowInfo="true" />

        <div class="info-container">
            <div class="detail-btn" @click="isRuleShow = true"></div>
            <div class="slogan"></div>
            <div class="get-btn" @click="getRequest"></div>
        </div>
        <Footer :gameName="gameName"></Footer>

        <!-- 登录弹窗 -->
        <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :downloadUrl="downloadUrl"
            :loginTypes="loginTypes"></Login>
        <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"
            @getSelectInfo="getSelectInfo"></Os>

        <!-- 活动规则弹窗 -->
        <div class="rule-wrap popup_wrap" v-show="isRuleShow">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut"
                :duration="{ enter: 1000 }">
                <div class="rule-box popup_wrap-box" v-show="isRuleShow">
                    <div class="rules_detail_wrap">
                        <img src="https://download4.qcplay.com/h5-images/active/sakura/info/rule-detail.png" alt="" />
                    </div>
                    <div class="close-bg" @click="isRuleShow = false"></div>
                </div>
            </transition>
        </div>

        <!-- 奖品弹窗 -->
        <div class="reward-wrap popup_wrap" v-show="isRewardShow">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut"
                :duration="{ enter: 1000 }">
                <div class="reward-box popup_wrap-box" v-show="isRewardShow">
                    <div class="receive-btn" @click="receiveItem"></div>
                    <div class="close-bg" @click="isRewardShow = false"></div>
                </div>
            </transition>
        </div>
        <!-- 没有奖品弹窗 -->
        <div class="nothing-wrap popup_wrap" v-show="isNothingShow">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut"
                :duration="{ enter: 1000 }">
                <div class="nothing-box popup_wrap-box" v-show="isNothingShow">
                    <div class="confirm" @click="isNothingShow = false"></div>
                    <div class="close-bg" @click="isNothingShow = false"></div>
                </div>
            </transition>
        </div>
        <!-- 填写信息成功弹窗 -->
        <div class="success-wrap popup_wrap" v-show="isSuccessShow">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut"
                :duration="{ enter: 1000 }">
                <div class="success-box popup_wrap-box" v-show="isSuccessShow">
                    <div class="confirm" @click="isSuccessShow = false"></div>
                    <div class="close-bg" @click="isSuccessShow = false"></div>
                </div>
            </transition>
        </div>
        <!-- 填写信息弹窗 -->
        <div class="info-wrap popup_wrap" v-show="isWriteShow">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut"
                :duration="{ enter: 1000 }">
                <div class="info-box popup_wrap-box" v-show="isWriteShow">
                    <div class="address">
                        <input v-model="getAddress" type="text" placeholder="请输入详细地址" />
                    </div>
                    <div class="door-number">
                        <input v-model="doorNumber" type="text" placeholder="请输入门牌号" />
                    </div>
                    <div class="people">
                        <input v-model="name" type="text" placeholder="请输入联系人" />
                    </div>
                    <div class="phone">
                        <input v-model="phone" type="text" placeholder="请输入手机号" />
                    </div>
                    <div class="cancel-btn" @click="closeWriteDialog"></div>
                    <div class="confirm-btn" @click="registerSuccess"></div>
                    <div class="close-bg" @click="closeWriteDialog"></div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
import { Toast } from "mint-ui";
import { headerConfig } from '../headerConfig'
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { onGetInitDataApi, submitInfoApi, secretFreeLoginApi } from '../api'

export default {
    name: "sakura-shake",
    components: {
        Header,
        Footer,
        Login,
        Os
    },

    data() {
        return {
            headerConfig,
            loginTypes: ["sms", "password"],
            gameName: "sakura",
            downloadUrl: "https://sakura.qingcijoy.com/official/index.html",
            isRuleShow: false,  // 规则弹窗
            isRewardShow: false, // 奖品弹窗
            isNothingShow: false, // 没有奖品的弹窗
            isSuccessShow: false, // 填写信息成功弹窗
            isWriteShow: false, //  填写信息弹窗
            // 游戏传过来的参数
            role_id: '',
            game_id: '',
            token: '',
            sign: '',
            // 提交信息的数据
            name: '', // 联系人
            phone: '', // 手机号
            getAddress: '', // 收货地址
            doorNumber: '', // 门牌号
            // 其他数据
            is_reward: "0"
        };
    },
    created() {
        // 清空store上的用户数据
        this.setInitActiveInfo();
        this.setInitUserInfo();
        if (this.$route.query.game_id && this.$route.query.role_id && this.$route.query.token) {
            this.game_id = this.$route.query.game_id
            this.role_id = this.$route.query.role_id
            this.token = this.$route.query.token
            this.sign = this.$route.query.sign
            this.secretFreeLogin()
        } else {
            this.initData();
        }
    },
    computed: {
        ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
    },
    watch: {
        userInfo: {
            handler(newValue, oldValue) {
                if (!newValue.role_id) {
                    // TAG: 注销的时候
                    this.is_reward = "0";
                } else if (newValue.role_id !== oldValue.role_id) {
                    // TAG: 初始登陆/切换角色的时候
                }
            }
        }
    },
    methods: {
        // 初始化接口
        initData() {
            onGetInitDataApi().then(res => {
                if (res.code === 200) {
                    this.is_reward = res.data.activity.is_reward;
                    this.onInitDataCallback(res);
                    this.setUserInfo(res.data.userinfo);
                    this.setActiveInfo(res.data.activity);
                    this.headerLogin = true
                } else {
                    this.headerLogin = false
                }
            });
        },
        // 从游戏链接跳转过来
        secretFreeLogin() {
            let params = {
                role_id: this.role_id,
                token: this.token,
                sign: this.sign,
                game_id: this.game_id
            }
            secretFreeLoginApi(params).then(res => {
                if (res.code === 200) {
                    this.initData()
                } else {
                    this.onToast(res.message)
                }
            })
        },
        // 提交信息接口请求
        submitInfo() {
            let params = {
                name: this.name,
                phone: this.phone,
                address: this.getAddress + this.doorNumber
            }
            submitInfoApi(params).then(res => {
                if (res.code === 200) {
                    this.isWriteShow = false
                    this.isSuccessShow = true
                    // 成功后调用初始化数据
                    this.initData()
                } else {
                    this.onToast(res.message)
                }
            })
        },
        // 点击立即领取
        getRequest() {
            // 如果没有登录唤起登录弹窗
            if (!this.userInfo.account) {
                return this.changeLoginPopup(true);
            } else if (this.is_reward != 1) {
                // 没有获奖的情况下唤起没有奖励的弹窗
                return this.isNothingShow = true
            }
            // 获奖了弹窗奖品弹窗
            this.isRewardShow = true
        },
        // 领取奖励
        receiveItem() {
            this.isRewardShow = false
            // 有填写过直接弹出登记成功的弹窗
            if (this.activeInfo.name) {
                this.isSuccessShow = true
            } else {
                // 没填过就弹出信息登记弹窗
                this.isWriteShow = true
            }
        },
        // 登记信息提交按钮
        registerSuccess() {
            if (!this.getAddress) {
                this.onToast("请输入详细收货地址！");
            } else if (!this.doorNumber) {
                this.onToast("请输入输入门牌号！");
            } else if (!this.name) {
                this.onToast("请输入联系人！");
            } else if (!this.phone) {
                this.onToast("请输入手机号！");
            } else {
                this.submitInfo();
            }
        },
        // 关闭登记信息弹窗
        closeWriteDialog() {
            this.getAddress = "";
            this.doorNumber = "";
            this.name = "";
            this.phone = "";
            this.isWriteShow = false;
        },
        // 获取选中的角色信息
        getSelectInfo(info, token) {
            this.token = token;
        },
        // 选择角色后
        selectCallback() {
            this.initData();
        },
        // 区组弹窗注销-相关参数复位
        osCancell() { },
        // TAG: 其他简易封装的方法
        onToast(config) {
            const curConfig = {
                duration: 1000,
                className: "toasts"
            };
            if (!config) {
                console.error("缺少config参数");
                return false;
            }
            if (typeof config === "string") {
                curConfig.message = config;
            }
            Toast(curConfig);
        },
        ...mapMutations([
            "changeLoginPopup",
            "changeOsPopup",
            "setInitActiveInfo",
            "setInitUserInfo",
            "setLogger",
            "setUserInfo",
            "setActiveInfo"
        ]),
        ...mapActions(["onInitDataCallback"])
    }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>


// WEBPACK FOOTER //
// src/pages/sakura/info/index/index.vue